import { useFieldArrayContext } from 'modules/linkExpirationManagement/contexts';
import { Button, BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { Modal, MODAL_VARIANTS, ModalBody, ModalFooter, ModalHeader } from 'ui/modal';

export const COPY_ALL_MODAL_TEXT = {
  modalId: 'copy-all-modal',
  title: 'Copy to all projects?',
  bodyText:
    'Are you sure you want to copy this setting to all projects? This will overwrite existing click link settings for all projects.',
  buttonId: 'copy-all-button',
  buttonText: 'Copy to all projects',
};

const { bodyText, buttonId, buttonText, modalId, title } = COPY_ALL_MODAL_TEXT;

type CopyAllModalProps = {
  onClose: () => void;
};

export const CopyAllModal = ({ onClose }: CopyAllModalProps) => {
  const { onSubmitAllFields } = useFieldArrayContext();

  return (
    <Modal id={modalId} isModalOpen onClose={onClose} variant={MODAL_VARIANTS.DELETE} withPortal>
      <ModalHeader onClose={onClose} autoFocus={false}>
        {title}
      </ModalHeader>
      <ModalBody>{bodyText}</ModalBody>
      <ModalFooter onClose={onClose}>
        <Button
          data-test={buttonId}
          onClick={() => {
            onSubmitAllFields();
            onClose();
          }}
          size={BUTTON_SIZES.LARGE}
          variant={BUTTON_VARIANTS.PRIMARY}
        >
          {buttonText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
